import React from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { undoToastAtom, hideUndoToastAtom, executeUndoAtom } from '../../atoms/v3/undoToastAtoms';
import { UndoToast } from './UndoToast';

interface UndoToastContainerProps {
  onUndo: (taskId: string, previousState: boolean) => void;
}

/**
 * 全局撤销 Toast 容器组件
 * 负责显示和管理撤销操作的 toast
 */
export const UndoToastContainer: React.FC<UndoToastContainerProps> = ({ onUndo }) => {
  const toastData = useAtomValue(undoToastAtom);
  const [, hideToast] = useAtom(hideUndoToastAtom);
  const [, executeUndo] = useAtom(executeUndoAtom);

  if (!toastData) {
    return null;
  }

  const handleUndo = () => {
    executeUndo(onUndo);
  };

  const handleDismiss = () => {
    hideToast();
  };

  return (
    <UndoToast
      taskTitle={toastData.taskTitle}
      isCompleted={toastData.isCompleted}
      onUndo={handleUndo}
      onDismiss={handleDismiss}
      duration={5000}
    />
  );
};
